import { useState } from 'react';
import { useLazyUserOrdersQuery } from '../../../graphql/graphql';

export default function useWalletTransactions(userId: string) {
	const [getWalletTransactions, { data, isLoading }] = useLazyUserOrdersQuery();
	const [page, setPage] = useState(1);

	const getFlatWalletTransaction = () => {
		getWalletTransactions({
			userId,
			skip: (page - 1) * 20,
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return {
		getFlatWalletTransaction,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	};
}
